module.exports = __webpack_public_path__ + "img/play-btn-blue.76b511a9.svg";